import { catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { IAppConfig, APP_CONFIG } from '../../../app.config';
import { Observable } from 'rxjs';
import { DataService } from '../../../core/service/base/data.service';
import { Company } from '../../../rent/model/company';
import { DebtCollection } from '../../model/debt-collection';
import { DebtCollectionCompany } from '../../model/const/enum';

@Injectable()
export class DebtCollectionService extends DataService<DebtCollection> {
  private readonly _defaultFilterFields: string[] = ['company', 'contactName', 'ocr', 'showFullyPaid'];

  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    super(_client, config, _messageService, DebtCollection, _progressBar, 'debt-collection');
  }

  getFilterDefinition(): Observable<{
    companyId: string;
    companies: Company[];
    contactName: string;
    ocr: string;
    showFullyPaid: boolean;
    externalSystem: DebtCollectionCompany;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client.get<any>(`${this.endpoint}/filter`).pipe(
      map(res => {
        return {
          companyId: res.companyId ? res.companyId : '',
          contactName: res.contactName ? res.contactName : '',
          ocr: res.ocr ? res.ocr : '',
          showFullyPaid: res.showFullyPaid ? res.showFullyPaid : '',
          externalSystem: res.externalSystem ? res.externalSystem : null,
          companies: Array.isArray(res.companies) ? res.companies.map(x => Object.assign(new Company(), x)) : [],
          selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._defaultFilterFields,
          defaultFields: this._defaultFilterFields,
        };
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }
}
